import { ValidationErrorData } from './common';
import { KeywordsEditorBodyView } from './keywordsEditorData';
import { MinusPhrasesShortLibraryItem } from './minusPhraseLibrary';

export interface MinusPhrasesValue {
    minusKeywords: string[];
    selectedLibraryList?: MinusPhrasesShortLibraryItem[];
}

export enum MinusPhrasesEditorTabs {
    libraryLists = 0,
    minusPhrases = 1
}

export interface MinusKeywordsEditorData {
    selectedLibraryListItems?: string[];
    addedLibraryList?: string;
    value: string[];
    isOpen: boolean;
    errors: ValidationErrorData[];
    view: KeywordsEditorBodyView;
    selectedTab: MinusPhrasesEditorTabs;
}

export interface AddLibraryListEditor {
    listTitle: string;
    minusPhrases: string;
    isVisible: boolean;
    isLoading?: boolean;
    errors: ValidationErrorData[];
}
